// @flow
import React from 'react';
import { Translation } from 'react-i18next';

import type {
  Values, Rules, FieldLabels, FieldErrors, ErrorMessages
} from '../types/form';

export default class Form {
  props: any;
  _values: Values;
  _errors: FieldErrors;

  constructor(props: any) {
    this._values = props;
    this._errors = {};
  }

  getTranslatedValue = (ns: String, key: String, options: Object) => {
    if (ns && key) {
      return <Translation ns={ns}>{(t) => t(key, options)}</Translation>;
    }
    return null;
  }

  get values(): Values {
    return this.keys.reduce((memo: any, field: string) => ({
      ...memo,
      [field]: this._values && this._values[field] ? this._values[field] : ''
    }), {});
  }

  get keys() : Array<string> {
    return [];
  }

  get rules() : Rules {
    return {};
  }

  get fieldLabels() : FieldLabels {
    return {};
  }

  get errors() : FieldErrors {
    return this._errors;
  }

  get hasErrors() : boolean {
    return Object.keys(this._errors).length > 0;
  }

  get errorMessages() : ErrorMessages {
    return {};
  }

  // All Forms with fields that have rules for validation must also have
  // custom error messages defined in errorMessages. Each field label
  // may have a different gender so error messages should be specific.
  validate(keysToValidate): void {
    const validationKeys = keysToValidate || Object.keys(this.values);
    this._errors = validationKeys.reduce((memo: any, key: string) => {
      const value = this.values[key];
      if (this.rules[key] && !this.rules[key](value)) {
        if (this.errorMessages[key]) {
          return {
            ...memo,
            [key]: this.errorMessages[key]
          };
        }
      }
      return memo;
    }, {});
  }
}



// WEBPACK FOOTER //
// ./src/models/Form.js